import { useState } from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { sentenceCase } from '../../../utils/utils';
import Text from '../../elements/text/Text';
import Title from '../../elements/title/Title';
import Modal from '../../sections/modal/Modal';

const StyledBox = styled('div')(({ theme }) => ({
  textAlign: 'left',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

const PasswordReset = ({ handleReset }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const toggleModal = () => setOpen((prev) => !prev);

  const onReset = async () => {
    await handleReset();
    toggleModal();
  };

  return (
    <>
      <Title subTitle text={t('passwordReset', { ns: 'sectionTitles' })} />

      <Text>{t('passwordChange', { ns: 'descriptions' })}</Text>
      <Text>{t('passwordResetButtonClicked', { ns: 'descriptions' })}</Text>

      <StyledBox>
        <Button color="error" onClick={toggleModal} aria-label="reset password">
          {t('reset', { ns: 'buttons' })}
        </Button>
        <Modal
          openModal={open}
          title={t('confirmation', {
            ns: 'sectionTitles',
            text: t('passwordReset', { ns: 'sectionTitles' }),
          })}
          handleConfirm={onReset}
          handleClose={toggleModal}
          showActions
        >
          <Text>
            {sentenceCase(
              t('resetAction', {
                ns: 'descriptions',
                text: t('password', { ns: 'fields' }),
              })
            )}
          </Text>
          <Text>{t('reset', { ns: 'descriptions' })}</Text>
        </Modal>
      </StyledBox>
    </>
  );
};

PasswordReset.propTypes = {
  handleReset: PropTypes.func.isRequired,
};

export default PasswordReset;
